// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to update cash & check asset counter values for each user
  </span>
</div>
<div class="alert">
  This command does not reset the current asset value, given
  value will be added to current value. If you wish to decrease counter value provide
  negative value in cash/check field
</div>
<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Branch:</td>
      <td>
        <select
          ng-model="\$ctrl.branchId"
          ng-options="branch.id as branch.name | prettyEnum for branch in \$ctrl.branches | orderBy:'name'"
          ng-change="\$ctrl.onBranchChange(\$ctrl.branchId)"
          required>
        </select>
      </td>
    </tr>
    <tr>
      <td>User:</td>
      <td>
        <select
          ng-model="\$ctrl.commandInput.userId"
          ng-options="user.id as user.username for user in \$ctrl.branchUsers | orderBy:'username'"
          ng-change="\$ctrl.onUserChange(\$ctrl.commandInput.userId)"
          ng-required="\$ctrl.branch"
          ng-disabled="!\$ctrl.branch">
        </select>
      </td>
    </tr>
    <tr>
      <td>Current cash:</td>
      <td>
        <cash value="\$ctrl.userCash"
          ng-disabled="true"></cash>
      </td>
    </tr>
    <tr>
      <td>Increase cash by:</td>
      <td>
        <cash min="-10000000000"
          ng-model="\$ctrl.commandInput.cashDiff"
          ng-required="\$ctrl.user"
          ng-disabled="!\$ctrl.user"></cash>
      </td>
    </tr>
    <tr>
      <td>Current check:</td>
      <td>
        <cash value="\$ctrl.userCheck"
          ng-disabled="true"></cash>
      </td>
    </tr>
    <tr>
      <td>Increase check by:</td>
      <td>
        <cash min="-10000000000"
          ng-model="\$ctrl.commandInput.checkDiff"
          ng-required="\$ctrl.user"
          ng-disabled="!\$ctrl.user"></cash>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-user-asset-counter/update-user-asset-counter.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;